import styles from "./styles.module.scss";

function Home() {
  return (
    <>
      <section className={styles.Container}>
        <div className={styles.bigtitle}>
          Politique de confidentialité
        </div>
        <div className={styles.content}>
          <div className={styles.title}>
             Le but de cette politique de confidentialité
          </div>
          <text>
          Le but de cette politique de confidentialité est d’informer les utilisateurs de notre site des données 
          personnelles que nous recueillerons ainsi que les informations suivantes, le cas échéant :
          </text>
          <div className={styles.numbers}>
          Les données personnelles que nous recueillerons
          </div>
          <div className={styles.numbers}>
          L’utilisation des données recueillies
          </div>
          <div className={styles.numbers}>
          Qui a accès aux données recueillies
          </div>
          <div className={styles.numbers}>
          Les droits des utilisateurs du site
          </div>
          <div className={styles.numbers}>
          La politique de cookies du site
          </div>
          <text>
          Cette politique de confidentialité fonctionne parallèlement aux mentions légales de notre site.
          </text>
        </div>
        <div className={styles.content}>
          <div className={styles.title}>
          Lois applicables
          </div>
          <text>
          Conformément au Règlement général sur la protection des données (RGPD), cette politique de confidentialité est conforme aux règlements suivants.
          </text>
        </div>
        <div className={styles.content}>
          <div className={styles.title}>
          Les données à caractère personnel doivent être :
          </div>
         
          <div className={styles.numbers}>
          traitées de manière licite, loyale et transparente au regard de la personne concernée (licéité, loyauté, transparence) 
          </div>
          <div className={styles.numbers}>
          collectées pour des finalités déterminées, explicites et légitimes, et ne pas être traitées ultérieurement d’une manière incompatible avec ces finalités; le traitement ultérieur à des fins archivistiques dans l’intérêt public, à des fins de recherche scientifique ou historique ou à des fins statistiques n’est pas considéré, conformément à l’article 89, paragraphe 1, comme incompatible avec les finalités initiales (limitation des finalités) 
          </div>
          <div className={styles.numbers}>
          adéquates, pertinentes et limitées à ce qui est nécessaire au regard des finalités pour lesquelles elles sont traitées (minimisation des données) 
          </div>
          <div className={styles.numbers}>
          exactes et, si nécessaire, tenues à jour; toutes les mesures raisonnables doivent être prises pour que les données à caractère personnel qui sont inexactes, eu égard aux finalités pour lesquelles elles sont traitées, soient effacées ou rectifiées sans tarder (exactitude) 
          </div>
          <div className={styles.numbers}>
          conservées sous une forme permettant l’identification des personnes concernées pendant une durée n’excédant pas celle nécessaire au regard des finalités pour lesquelles elles sont traitées; les données à caractère personnel peuvent être conservées pour des durées plus longues dans la mesure où elles seront traitées exclusivement à des fins archivistiques dans l’intérêt public, à des fins de recherche scientifique ou historique ou à des fins statistiques conformément à l’article 89, paragraphe 1, pour autant que soient mises en œuvre les mesures techniques et organisationnelles appropriées requises par le règlement afin de garantir les droits et libertés de la personne concernée (limitation de la conservation)
          </div>
          <div className={styles.numbers}>
          traitées de façon à garantir une sécurité appropriée des données à caractère personnel, y compris la protection contre le traitement non autorisé ou illicite et contre la perte, la destruction ou les dégâts d’origine accidentelle, à l’aide de mesures techniques ou organisationnelles appropriées (intégrité et confidentialité)
          </div>
        </div>
        <div className={styles.content}>
          <div className={styles.title}>
          Le traitement n’est licite que si, et dans la mesure où, au moins une des conditions suivantes est remplie :
          </div>
       
          <div className={styles.numbers}>
          la personne concernée a consenti au traitement de ses données à caractère personnel pour une ou plusieurs finalités spécifiques
          </div>
          <div className={styles.numbers}>
          le traitement est nécessaire à l’exécution d’un contrat auquel la personne concernée est partie ou à l’exécution de mesures précontractuelles prises à la demande de celle-ci
          </div>
          <div className={styles.numbers}>
          le traitement est nécessaire au respect d’une obligation légale à laquelle le responsable du traitement est soumis
          </div>
          <div className={styles.numbers}>
          le traitement est nécessaire à la sauvegarde des intérêts vitaux de la personne concernée ou d’une autre personne physique
          </div>
          <div className={styles.numbers}>
          le traitement est nécessaire à l’exécution d’une mission d’intérêt public ou relevant de l’exercice de l’autorité publique dont est investi le responsable du traitement 
          </div>
          <div className={styles.numbers}>
          le traitement est nécessaire aux fins des intérêts légitimes poursuivis par le responsable du traitement ou par un tiers, à moins que ne prévalent les intérêts ou les libertés et droits fondamentaux de la personne concernée qui exigent une protection des données à caractère personnel, notamment lorsque la personne concernée est un enfant
          </div>
         
        </div>
        <div className={styles.content}>
          <div className={styles.title}>
          Consentement
          </div>
          <text>
          Les utilisateurs conviennent qu’en utilisant notre site, ils consentent à
          </text>
          <div className={styles.numbers}>
          les conditions énoncées dans la présente politique de confidentialité
          </div>
          <div className={styles.numbers}>
          la collecte, l’utilisation et la conservation des données énumérées dans la présente politique
          </div>
    
        </div>
        <div className={styles.content}>
          <div className={styles.title}>
          Données collectées automatiquement
          </div>
          <text>
          Lorsque vous visitez et utilisez notre site, nous pouvons automatiquement recueillir et conserver les renseignements suivants :
          </text>
          <div className={styles.numbers}>
          Contenu que l’utilisateur consulte sur le site (pages, durée de navigation…)
          </div>
        </div>
        <div className={styles.content}>
          <div className={styles.title}>
          Comment nous utilisons les données personnelles
          </div>
          <text>
          Les données personnelles recueillies sur notre site seront utilisées uniquement aux fins précisées dans la présente politique ou indiquées sur les pages pertinentes de notre site. Nous n’utiliserons pas vos données au-delà de ce que nous divulguerons.
          </text>
          
        </div>
        <div className={styles.content}>
          <div className={styles.title}>
          Les données que nous recueillons automatiquement sont utilisées aux fins suivantes :
          </div>
        
          <div className={styles.numbers}>
          Statistiques pour nous aider à améliorer le site
          </div>
       
        </div>
        <div className={styles.content}>
          <div className={styles.title}>
          Les données que nous recueillons lorsque l’utilisateur exécute certaines fonctions peuvent être utilisées aux fins suivantes :
          </div>
         
          <div className={styles.numbers}>
          Les données que nous recueillons lorsque l’utilisateur exécute certaines fonctions peuvent être utilisées aux fins suivantes :
          </div>
    
        </div>
        <div className={styles.content}>
          <div className={styles.title}>
          Avec qui nous partageons les données personnelles
          </div>
          <div className={styles.title}>
          Employés
          </div>
          <text>
          Nous pouvons divulguer à tout membre de notre organisation les données utilisateur dont il a raisonnablement besoin pour réaliser les objectifs énoncés dans la présente politique.
          </text>
        
        </div>
        <div className={styles.content}>
          <div className={styles.title}>
          Modifications
          </div>
          <text>
          Cette politique de confidentialité peut être modifiée à l’occasion afin de maintenir la conformité avec la loi et de tenir compte de tout changement à notre processus de collecte de données. Nous recommandons à nos utilisateurs de vérifier notre politique de temps à autre pour s’assurer qu’ils soient informés de toute mise à jour. Au besoin, nous pouvons informer les utilisateurs par courriel des changements apportés à cette politique.
          </text>

          <text>

         </text>
        </div>
        <div className={styles.content}>
          <div className={styles.title}>
          Contact
          </div>
          <text>
          Si vous avez des questions à nous poser, n’hésitez pas à communiquer avec nous en utilisant ce qui suit :
          hello@orgaexpert.fr
          </text>
          <text>
          Date d’entrée en vigueur : le 01/01/2022
         </text>
        </div>
        <img src="/images/logo.png" alt="logo" />
      </section>
    </>
  );
}

export default Home;